import * as React from 'react'
import { Input, InputProps } from 'reactstrap'

type OnChangeHandler = (newValue: any) => void

interface IComponentProps extends InputProps {
  onChange?: OnChangeHandler
}

export default class CustomInput extends React.PureComponent<IComponentProps> {
  public render() {
    const { bsSize, className, style, children, onChange, ...otherProps } =
      this.props

    return <>{!children ? this._renderInput(otherProps, onChange) : children}</>
  }

  private _renderInput(props: InputProps, onChange?: OnChangeHandler) {
    return (
      <Input
        onChange={(e) => {
          if (onChange) {
            props.type === 'number'
              ? onChange(e.target.valueAsNumber)
              : onChange(e.target.value)
          }
        }}
        onKeyPress={(e) => {
          // This is done because Safari does not handle <input type='number' /> correctly when a comma or letter
          // is typed into the number input, it clears the value instead of preventing the character from being entered
          if (props.type === 'number' && !/[0-9\\.]/.test(e.key)) {
            e.preventDefault()
            e.stopPropagation()
          }
        }}
        {...props}
      />
    )
  }
}
